import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

// Store all SplitText instances for cleanup
let splitTextInstances = [];

export const splitText = (elements, options = {}) => {
	const {
		types = "lines",
		lineStyles = { opacity: 0, yPercent: 100, willChange: "transform" },
		track = true,
	} = options;

	// Ensure elements is an array
	const elementsArray = Array.isArray(elements) ? elements : [elements];
	const splits = [];

	elementsArray.forEach((element) => {
		// Convert "lines, words" format to "lines,words" (no spaces) for GSAP SplitText
		const type = types.replace(/\s+/g, "");

		const split = new SplitText(element, {
			type,
		});

		splits.push(split);

		// Track instance for cleanup if requested
		if (track) {
			splitTextInstances.push(split);
		}

		// Wrap each line in a parent div with overflow hidden for clipping effect
		if (split.lines && split.lines.length > 0) {
			split.lines.forEach((line) => {
				// Create wrapper with overflow hidden
				const wrapper = document.createElement("div");
				wrapper.style.overflow = "hidden";

				// Insert wrapper before line and move line into wrapper
				line.parentNode.insertBefore(wrapper, line);
				wrapper.appendChild(line);
			});

			// Apply animation styles to the inner line elements
			if (lineStyles) {
				gsap.set(split.lines, lineStyles);
			}
		}
	});

	return splits;
};


export const animateSplits = (splits, options = {}) => {
	const {
		duration = 1.4,
		stagger = 0.1,
		staggerDelay = 0,
		ease = "power3.out",
		animationProps = { opacity: 1, yPercent: 0 },
	} = options;

	const splitsArray = Array.isArray(splits) ? splits : [splits];

	splitsArray.forEach((split, index) => {
		if (split.lines && split.lines.length > 0) {
			gsap.to(split.lines, {
				...animationProps,
				duration,
				delay: index * staggerDelay,
				stagger,
				ease,
			});
		}
	});
};

export const cleanupAllSplits = () => {
	splitTextInstances.forEach((instance) => instance.revert());
	splitTextInstances = [];
};

export const getTrackedSplits = () => splitTextInstances;
